import type { FC, ReactNode } from 'react';
import { useStrategySelectorContext } from './StrategySelectorContext';
import styles from './StrategySelector.module.css';

interface StrategySelectorTitleProps {
  children: ReactNode;
}

export const StrategySelectorTitle: FC<StrategySelectorTitleProps> = ({ children }) => {
  const { expanded, strategies, selectedKeys } = useStrategySelectorContext();

  return (
    <h2 className={styles.sectionTitle}>
      <span className={styles.collapseIcon} data-expanded={expanded}>
        &#9656;
      </span>
      {children}
      {strategies.length > 0 && (
        <span className={styles.badge}>
          {selectedKeys.size}/{strategies.length}
        </span>
      )}
    </h2>
  );
};
